import { createSlice } from '@reduxjs/toolkit';

import { AuthState } from './auth-state';
import { fetchAccessTokenActionCreator } from './action-creators/fetch-access-token-action-creator';

const initialState: AuthState = {
    failed: false,
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        resetState: () => initialState,
        setAuthenticationKeys: (state, action) => {
            state.codeVerifier = action.payload.codeVerifier;
            state.authenticationKey = action.payload.authenticationKey;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchAccessTokenActionCreator.pending, (state) => {
            state.failed = false;
        });
        builder.addCase(fetchAccessTokenActionCreator.fulfilled, (state, action) => {
            state.failed = false;
            state.authInfo = action.payload;
        });
        builder.addCase(fetchAccessTokenActionCreator.rejected, (state) => {
            state.failed = true;
        });
    },
});

export const { actions: authSliceActions, reducer: authSliceReducer } = authSlice;
